const ICON_COMPASS = 'M12.284 24v-3.423c2.136-.107 3.986-.866 5.536-2.281l2.427 2.422a11.3 11.3 0 0 1-2.246 1.68 11.8 11.8 0 0 1-5.024 1.562 1 1 0 0 0-.18.04zM24 12.798c-.062.447-.11.896-.191 1.339a11.86 11.86 0 0 1-3.023 6.042 1 1 0 0 1-.07.063l-2.421-2.419c1.405-1.542 2.173-3.39 2.279-5.54H24zM11.206 24c-.5-.074-1.004-.133-1.5-.227a11.7 11.7 0 0 1-5.32-2.5c-.217-.177-.424-.368-.612-.53l2.43-2.43c1.525 1.39 3.369 2.154 5.517 2.263V24zM24 11.72h-3.423c-.108-2.138-.868-3.99-2.285-5.542l2.442-2.444c.341.425.712.845 1.036 1.3a11.8 11.8 0 0 1 2.187 5.991q.015.114.043.227zM16.486 10.163c-.244-.562-.204-.89.125-1.148a.8.8 0 0 1 .96-.013.79.79 0 0 1 .271.92c-.142.378-.472.543-1 .485-.03.087-.067.178-.097.272-.3.928-.602 1.854-.898 2.783-.04.129-.095.183-.24.182q-3.574-.008-7.148 0c-.144 0-.201-.053-.245-.18-.326-.96-.662-1.917-.983-2.875-.058-.175-.125-.241-.322-.231-.418.022-.758-.309-.795-.73-.035-.395.255-.76.665-.838a.8.8 0 0 1 .897.58c.062.23-.019.427-.118.625-.028.058-.028.178.01.214.61.568 1.23 1.125 1.86 1.7l2.101-1.948c-.405-.5-.424-.947-.062-1.27a.79.79 0 0 1 1.1.033c.345.352.303.794-.128 1.245l2.133 1.937zM20.255 3.281l-2.427 2.432q-2.33-2.124-5.521-2.284V0c3.07.116 5.71 1.21 7.948 3.281M3.43 12.304q.162 3.19 2.284 5.52L3.282 20.25Q.18 16.91.005 12.305zM6.179 5.714l-2.41-2.409C5.004 1.645 9.214-.11 11.69.017v3.41c-2.106.108-3.957.867-5.511 2.287M0 11.696q.185-4.605 3.27-7.93l2.423 2.436c-1.392 1.527-2.155 3.37-2.262 5.5zM8.275 14.09h7.46c.052.714-.585 1.412-1.335 1.42q-2.4.024-4.802 0c-.75-.009-1.401-.731-1.323-1.42';

const ICON_BADGE = 'M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m1.564-1.607a11.5 11.5 0 0 1-3.136 0 .436.436 0 0 1-.364-.52l.26-1.326a.47.47 0 0 1 .52-.368 9.4 9.4 0 0 0 2.305 0 .47.47 0 0 1 .52.368l.26 1.326a.436.436 0 0 1-.365.52M10.428 1.607a11.5 11.5 0 0 1 3.136 0c.25.034.412.273.364.52l-.26 1.326a.47.47 0 0 1-.52.368 9.4 9.4 0 0 0-2.304 0 .47.47 0 0 1-.52-.368l-.26-1.326a.436.436 0 0 1 .364-.52m11.74 14.31A10.4 10.4 0 0 1 20.6 18.51a.436.436 0 0 1-.615.053l-1.03-.847a.47.47 0 0 1-.06-.657 8.3 8.3 0 0 0 1.134-1.89.47.47 0 0 1 .578-.267l1.293.436c.24.08.367.345.269.578M1.828 8.084q.285-.68.68-1.335.403-.67.89-1.259a.436.436 0 0 1 .614-.053l1.03.847a.47.47 0 0 1 .06.657 8.3 8.3 0 0 0-1.135 1.89.47.47 0 0 1-.578.267l-1.293-.435a.435.435 0 0 1-.268-.579m18.772-2.594a.436.436 0 0 0-.614-.053l-1.031.847a.47.47 0 0 0-.06.657 8.2 8.2 0 0 1 1.135 1.89.47.47 0 0 0 .578.267l1.293-.436a.435.435 0 0 0 .269-.578q-.287-.681-.68-1.335a10.6 10.6 0 0 0-.89-1.259M3.396 18.51a.436.436 0 0 0 .614.053l1.031-.846a.47.47 0 0 0 .06-.658 8.2 8.2 0 0 1-1.135-1.89.47.47 0 0 0-.578-.267l-1.293.436a.435.435 0 0 0-.268.578q.285.681.679 1.334.404.67.89 1.26m12.71-5.78c.526-.324.526-1.136 0-1.46l-5.922-3.656C9.658 7.29 9 7.696 9 8.345v7.31c0 .65.658 1.056 1.184.73z';

const ICON_CROWN = 'M15.879 3.332c1.683 2.31 1.82 2.44 2.59 2.463.797.023.81.038.667.798-.136.729-.02.906 1.97 2.993 1.954 2.05 2.087 2.248 1.75 2.614-.201.218-.47.373-.599.344-.128-.029-.998-1.099-1.933-2.378-.936-1.28-1.772-2.278-1.858-2.22s-.028.333.13.61c.158.279.273.58.255.67-.017.09-.538.623-1.157 1.183s-1.145 1.124-1.17 1.252 1.142 1.666 2.592 3.417c2.98 3.596 3.244 4.046 2.75 4.677-.774.99-2.256 2.036-2.724 1.924-.271-.065-1.71-1.603-3.272-3.497-1.534-1.86-2.86-3.397-2.95-3.417-.088-.02-.585.327-1.104.771-.52.445-1.656 1.33-2.525 1.966-1.58 1.158-1.58 1.158-.72 2.19.474.567.825 1.218.78 1.444-.104.538-1.5 1.793-2.068 1.86-.271.033-.655-.19-.99-.574-1.792-2.059-1.562-1.899-2.39-1.666-1.418.399-1.811-.068-1.15-1.363.337-.659.318-.767-.252-1.45a20 20 0 0 1-1.125-1.52c-.5-.767-.5-.79-.003-1.32.859-.917 1.595-1.377 2.044-1.276.236.053.77.521 1.19 1.041.417.52.817.841.888.714.07-.127 1.042-1.148 2.16-2.268 1.116-1.121 2.087-2.1 2.157-2.175.07-.076-1.166-1.685-2.746-3.577C5.486 5.669 4.142 3.905 4.08 3.64c-.088-.374.15-.72 1.074-1.555C7.04.378 6.828.27 10.596 4.834c1.364 1.652 2.56 3.014 2.658 3.027s.776-.484 1.508-1.104c1.177-.998 1.376-1.087 1.735-.774.223.194.465.313.538.263s-.778-1.083-1.892-2.296c-1.115-1.213-2.014-2.271-1.998-2.352s.238-.272.493-.426c.433-.26.584-.115 2.24 2.16';

const ICON_SPORT = 'M21.722 2.2c0-1.03-.836-1.867-1.867-1.867H4.145c-1.032 0-1.868.836-1.868 1.867l-1.944.078v1.944c0 4.753 3.759 8.643 8.459 8.857q.464.263.957.45l-1.638 8.193h-.972a.972.972 0 1 0 0 1.945h9.722a.972.972 0 1 0 0-1.945h-.972L14.25 13.53q.494-.187.957-.451c4.7-.214 8.46-4.104 8.46-8.857V2.278zM2.51 4.222h1.633s.624 4.086 1.548 5.685A6.68 6.68 0 0 1 2.51 4.222m15.797 5.685c.924-1.6 1.547-5.685 1.547-5.685h1.633a6.68 6.68 0 0 1-3.18 5.685';

const PARTICIPANTS_PATH = 'M12.119 6.175A3.155 3.155 0 0 1 8.962 9.35a3.155 3.155 0 0 1-3.157-3.175A3.154 3.154 0 0 1 8.962 3a3.154 3.154 0 0 1 3.157 3.175M8.962 15c-2.574 0-4.77-.408-4.77-2.04s2.182-2.055 4.77-2.055c2.573 0 4.77.408 4.77 2.04S11.55 15 8.963 15m4.506-8.768c0 .898-.268 1.735-.738 2.43a.12.12 0 0 0 .08.184q.177.03.362.035c1.233.032 2.339-.765 2.644-1.966.453-1.784-.876-3.386-2.568-3.386q-.275.001-.532.055c-.023.006-.048.016-.061.037-.016.026-.005.06.012.083.508.716.8 1.59.8 2.528m2.04 3.902c.829.163 1.373.495 1.599.979.19.396.19.856 0 1.252-.345.749-1.458.99-1.89 1.051-.09.014-.162-.064-.152-.154.22-2.075-1.537-3.06-1.991-3.286-.02-.01-.024-.025-.022-.035.002-.007.01-.017.024-.02.984-.018 2.042.118 2.433.213M4.829 8.881q.185-.004.362-.035a.12.12 0 0 0 .08-.183 4.32 4.32 0 0 1-.738-2.431c0-.938.293-1.812.802-2.528.016-.023.027-.057.012-.083-.014-.02-.04-.032-.062-.037a2.6 2.6 0 0 0-.532-.055c-1.692 0-3.021 1.602-2.568 3.386.305 1.2 1.412 1.998 2.644 1.966m.12 1.06c.002.01-.002.025-.021.036-.455.226-2.213 1.21-1.992 3.285.01.09-.062.168-.151.155-.433-.062-1.545-.303-1.89-1.052a1.44 1.44 0 0 1 0-1.252c.225-.483.77-.816 1.597-.979.392-.095 1.449-.23 2.433-.212.015.002.022.013.024.019';

export function IconCompass() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#FFC200" d={ICON_COMPASS} />
    </svg>
  );
}

export function IconBadge() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#FFC200" fillRule="evenodd" d={ICON_BADGE} clipRule="evenodd" />
    </svg>
  );
}

export function IconCrown() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#FFC200" fillRule="evenodd" d={ICON_CROWN} clipRule="evenodd" />
    </svg>
  );
}

export function IconSport() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
      <g clipPath="url(#tournament-sport-clip)">
        <path fill="#FFC200" d={ICON_SPORT} />
      </g>
      <defs>
        <clipPath id="tournament-sport-clip">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const TITLE_ICONS = {
  compass: IconCompass,
  badge: IconBadge,
  crown: IconCrown,
  sport: IconSport,
};

export function TournamentTitleIcon({ variant = 'compass' }) {
  const Icon = TITLE_ICONS[variant] || IconCompass;
  return <Icon />;
}

export function IconParticipants() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#fff" fillRule="evenodd" d={PARTICIPANTS_PATH} clipRule="evenodd" />
    </svg>
  );
}

export function IconPlaces() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" aria-hidden="true">
      <path fill="#fff" d="M8.166 12.167h-1.5c-.733 0-1.333.6-1.333 1.333v.167h-.667c-.273 0-.5.226-.5.5 0 .273.227.5.5.5h8c.274 0 .5-.227.5-.5 0-.274-.226-.5-.5-.5H12V13.5c0-.733-.6-1.333-1.334-1.333h-1.5V10.64q-.25.028-.5.027-.25.002-.5-.027z" />
      <path fill="#fff" d="M12.987 7.76c.44-.167.826-.44 1.133-.747.62-.686 1.027-1.506 1.027-2.466s-.754-1.714-1.714-1.714h-.373a2.66 2.66 0 0 0-2.394-1.5h-4c-1.053 0-1.96.614-2.393 1.5H3.9c-.96 0-1.713.754-1.713 1.714s.406 1.78 1.026 2.466c.307.307.694.58 1.134.747a4.65 4.65 0 0 0 4.32 2.907c1.96 0 3.626-1.2 4.32-2.907M10.56 5.633l-.414.507a.5.5 0 0 0-.106.32l.04.653c.027.4-.26.607-.633.46l-.607-.24a.6.6 0 0 0-.347 0l-.606.24c-.374.147-.66-.06-.634-.46l.04-.653a.5.5 0 0 0-.106-.32l-.414-.507c-.26-.306-.146-.646.24-.746l.634-.16a.53.53 0 0 0 .273-.207l.353-.547c.22-.34.567-.34.787 0l.353.547a.53.53 0 0 0 .274.207l.633.16c.386.1.5.44.24.746" />
    </svg>
  );
}

export function IconClock() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" aria-hidden="true">
      <path fill="currentColor" fillRule="evenodd" d="M8.334 14.667A6.665 6.665 0 0 1 1.667 8a6.67 6.67 0 0 1 6.667-6.667A6.665 6.665 0 0 1 15 8a6.66 6.66 0 0 1-6.666 6.667m2.126-4.194a.495.495 0 0 0 .687-.173.5.5 0 0 0-.173-.687L8.6 8.2V5.12a.5.5 0 1 0-1 0v3.367a.5.5 0 0 0 .247.426z" clipRule="evenodd" />
    </svg>
  );
}

let _coinUid = 0;

export function IconCoin({ size = 14 }) {
  _coinUid += 1;
  const uid = `coin_svg_${_coinUid}`;
  const a = `${uid}__a`;
  const b = `${uid}__b`;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width={size} height={size} aria-hidden="true">
      <defs>
        <linearGradient id={a} x1="7" y1="0" x2="7" y2="14" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F6D36A" />
          <stop offset="1" stopColor="#C69020" />
        </linearGradient>
        <linearGradient id={b} x1="7" y1="0" x2="7" y2="14" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E8B84A" />
          <stop offset="0.5" stopColor="#A87218" />
          <stop offset="1" stopColor="#F0C35A" />
        </linearGradient>
      </defs>
      <path fill={`url(#${a})`} d="M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0" />
      <path
        fill={`url(#${b})`}
        fillRule="evenodd"
        d="M7 12.099A5.099 5.099 0 1 0 7 1.9 5.099 5.099 0 0 0 7 12.1M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14"
        clipRule="evenodd"
      />
    </svg>
  );
}

const BONUS_ICON_PATH = 'M6.499 1.33C7.997.57 9.32.193 11.099.023c.383-.037 1.47-.028 1.948.017 1.54.142 2.835.508 4.225 1.194 1.33.657 2.325 1.38 3.339 2.428a11.6 11.6 0 0 1 2.15 3.041 11.67 11.67 0 0 1 1.231 5.693c-.066 1.859-.49 3.48-1.339 5.113a12.24 12.24 0 0 1-4.066 4.517c-.625.415-1.838 1.023-2.534 1.268-2.293.811-4.648.924-6.996.335-.895-.224-1.464-.434-2.347-.867-1.265-.62-2.161-1.264-3.195-2.296-1.044-1.044-1.677-1.926-2.323-3.239-.571-1.16-.936-2.37-1.133-3.752-.079-.551-.079-2.403 0-2.954.113-.794.298-1.595.53-2.298.29-.872.89-2.107 1.382-2.838C3.13 3.658 4.724 2.232 6.499 1.33m15.023 6.046a10.63 10.63 0 0 0-8.569-5.93c-2.8-.256-5.637.642-7.816 2.473-2.344 1.97-3.755 5.006-3.755 8.079 0 3.071 1.418 6.12 3.755 8.077 1.533 1.283 3.297 2.082 5.328 2.412.721.117 2.33.117 3.052 0 1.183-.192 2.084-.473 3.098-.966a10.54 10.54 0 0 0 4.907-4.901c.495-1.017.776-1.916.968-3.098.117-.72.117-2.328 0-3.048-.192-1.182-.473-2.081-.968-3.098M12.616 7.2a.724.724 0 0 0-1.232 0l-1.51 2.439a.7.7 0 0 1-.235.234l-2.44 1.511a.724.724 0 0 0 0 1.232l2.44 1.51q.144.091.234.235l1.511 2.439a.724.724 0 0 0 1.232 0l1.51-2.44a.7.7 0 0 1 .235-.233l2.439-1.511a.724.724 0 0 0 0-1.232l-2.44-1.51a.7.7 0 0 1-.233-.235z';

export function IconGift() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      aria-hidden="true"
      style={{ color: 'var(--bonus-fill, #E88A00)' }}
    >
      <path fill="currentColor" fillRule="evenodd" d={BONUS_ICON_PATH} clipRule="evenodd" />
    </svg>
  );
}

export function IconFsStar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      aria-hidden="true"
      style={{ color: 'var(--freespin-fill, #965CC0)' }}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.804 1.706a12.06 12.06 0 0 1 8.757-1.43c6.483 1.42 10.568 7.81 9.162 14.268-1.42 6.48-7.828 10.586-14.289 9.18C3.152 22.344-.937 16.243.185 9.915c.19-1.036 1.745-.75 1.592.279-.971 5.491 2.579 10.77 8.018 11.963 5.58 1.223 11.127-2.336 12.367-7.936 1.217-5.614-2.344-11.16-7.96-12.377a10.36 10.36 0 0 0-7.65 1.28l.923.923c.095.098.034.283-.122.273l-3.944-.3L5.247.484c.054-.125.269-.108.297.04z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.32 5.795a1.64 1.64 0 0 0-2.641 0l-1.295 1.76a1.64 1.64 0 0 1-.804.584l-2.074.687a1.64 1.64 0 0 0-.816 2.513l1.273 1.775c.198.276.305.606.307.945l.014 2.185a1.64 1.64 0 0 0 2.137 1.553l2.081-.663c.324-.103.671-.103.995 0l2.081.663a1.64 1.64 0 0 0 2.137-1.553l.014-2.184c.002-.34.11-.67.307-.946l1.273-1.775a1.64 1.64 0 0 0-.816-2.513L15.42 8.14a1.64 1.64 0 0 1-.805-.585z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function RankHexagon({ rank }) {
  const n = Number(rank) || 0;
  const tone = n === 1 ? 'gold' : n === 2 ? 'silver' : n === 3 ? 'bronze' : 'plain';
  const fills = {
    gold: { a: '#FFD86B', b: '#C9971A' },
    silver: { a: '#F3F5F7', b: '#9AA3AD' },
    bronze: { a: '#E0A36A', b: '#8D5524' },
    plain: { a: 'rgba(255,255,255,.18)', b: 'rgba(255,255,255,.08)' },
  };
  const f = fills[tone];
  const gid = `hexagon${tone[0].toUpperCase()}${tone.slice(1)}_svg__a-${n}`;
  return (
    <div className={`tournament-dialog__hex-wrap tournament-dialog__hex-wrap--${tone}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 34" width="32" height="34" aria-hidden="true" className={`tournament-dialog__hex tournament-dialog__hex--${tone}`}>
        <defs>
          <linearGradient id={gid} x1="16" y1="0" x2="16" y2="34" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor={f.a} />
            <stop offset="100%" stopColor={f.b} />
          </linearGradient>
        </defs>
        <path fill={`url(#${gid})`} d="M14.97.618a2 2 0 0 1 2.06 0l11.323 6.8a2 2 0 0 1 .97 1.714v13.736a2 2 0 0 1-.97 1.715L17.03 31.382a2 2 0 0 1-2.06 0L3.647 24.583a2 2 0 0 1-.97-1.715V9.132a2 2 0 0 1 .97-1.714z" />
      </svg>
      <span className="tournament-dialog__hex-num">{n || '—'}</span>
    </div>
  );
}
